import React from "react";
import { Link } from "react-router-dom";

function AddSoarCorrespondence({ contact }) {
  return (
    <Link
      title="SOAR Correspondence"
      to={`/correspondence`}
      state={{
        contact: contact,
      }}
      className="me-1 btn bg-safy3-1 text-white"
    >
      <i className={"fas fa-plus-circle me-1 text-white"} />
      SOAR Correspondence
    </Link>
  );
}

export default AddSoarCorrespondence;
